import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "relative flex items-stretch self-stretch rounded" }
const _hoisted_2 = { class: "w-full overflow-hidden rounded flex flex-col bg-neutral-100" }
const _hoisted_3 = { class: "flex justify-start space-x-2 w-full" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "p-4 flex-1 lg:p-8 !pt-0 space-y-2" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "font-bold leading-tight" }
const _hoisted_9 = { class: "block truncate text-xs text-black/50" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("p", null, " Artist that archives Black Trans experience in video games and animation. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.creator.collections.slice(0, 3), (src) => {
          return (_openBlock(), _createElementBlock("img", {
            class: "rounded w-1/3",
            key: src,
            src: src,
            alt: ""
          }, null, 8, _hoisted_4))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("img", {
          class: "relative -mt-8 mx-auto w-16 h-16 rounded-full border-2",
          src: _ctx.creator.avatar,
          alt: ""
        }, null, 8, _hoisted_6),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("h5", _hoisted_8, _toDisplayString(_ctx.creator.name), 1),
          _createElementVNode("span", _hoisted_9, _toDisplayString("@" + _ctx.creator.username), 1)
        ]),
        _hoisted_10
      ])
    ])
  ]))
}